import type { TimelineDto, TimelineParams } from '../types';

function addDays(dateOnly: string, days: number): string {
  const d = new Date(`${dateOnly}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().split('T')[0];
}

function clamp(dateOnly: string, min: string, max: string): string {
  if (dateOnly < min) return min;
  if (dateOnly > max) return max;
  return dateOnly;
}

/**
 * In-memory mock for `GetTimeline` — mirrors the real endpoint's `userIds`
 * narrowing (only returns data for requested IDs) and clamps mock dates into
 * the requested `[dateStart, dateEnd]` window, so navigating weeks in mock
 * mode still shows milestones/absences move with the visible range.
 */
export function getMockTimelineResult(params: TimelineParams): TimelineDto {
  const requestedIds = params.userIds
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);

  const milestoneOwnerId = requestedIds[0];
  const absenceUserId = requestedIds[1] ?? requestedIds[0];

  const milestones: TimelineDto['milestones'] = milestoneOwnerId
    ? [
        {
          id: 'milestone-1',
          title: 'Reunión de planeación Q2',
          personUserId: milestoneOwnerId,
          date: { date: clamp(addDays(params.dateStart, 3), params.dateStart, params.dateEnd) },
        },
      ]
    : [];

  const absenceStart = clamp(addDays(params.dateStart, 5), params.dateStart, params.dateEnd);
  const absences: TimelineDto['absences'] = absenceUserId
    ? [
        { userId: absenceUserId, date: absenceStart },
        {
          userId: absenceUserId,
          date: clamp(addDays(absenceStart, 1), params.dateStart, params.dateEnd),
        },
      ]
    : [];

  return { milestones, absences };
}
